import { useTranslation } from "react-i18next";
import { Gauge } from "lucide-react";
import { NeuCard } from "../../../components/neu/Neu";

const Stat = ({ label, value, tone = "text-foreground" }) => (
  <div className="rounded-2xl bg-background p-3 shadow-neu-sm">
    <p className="text-[10px] font-bold text-muted-foreground">{label}</p>
    <p className={`mt-1 font-mono text-lg font-black ${tone}`}>{value}</p>
  </div>
);

export const PerformanceCard = ({ data, onOpen }) => {
  const { t } = useTranslation();
  if (!data) return null;
  const slow = data.avg_ms > 500;

  return (
    <NeuCard
      data-testid="system-performance-card"
      onClick={onOpen}
      className="cursor-pointer transition-transform duration-300 hover:-translate-y-0.5"
    >
      <p className="label-xs flex items-center gap-2">
        <Gauge className="h-4 w-4 text-primary" /> {t("system.performance", { hours: data.window_hours })}
      </p>

      <div className="mt-4 grid grid-cols-2 gap-2.5 sm:grid-cols-3">
        <Stat label={t("system.requests")} value={data.requests.toLocaleString("en-GB")} />
        <Stat label={t("system.avgMs")} value={`${data.avg_ms} ms`} tone={slow ? "text-amber-500" : "text-primary"} />
        <Stat label={t("system.maxMs")} value={`${data.max_ms} ms`} />
        <Stat
          label={t("system.serverErrors")}
          value={data.server_errors}
          tone={data.server_errors ? "text-destructive" : "text-primary"}
        />
        <Stat label={t("system.clientErrors")} value={data.client_errors} />
        <Stat label={t("system.uptime")} value={`${data.uptime_hours} h`} />
      </div>

      <p className="mt-4 text-xs font-bold text-muted-foreground">{t("system.slowest")}</p>
      <ul className="mt-2 grid gap-1.5 font-mono text-[11px]" data-testid="system-slowest">
        {data.slowest_paths.map((p) => (
          <li key={p.path} className="flex items-center justify-between gap-3 rounded-xl bg-background px-3 py-2 shadow-neu-sm">
            <span className="truncate text-muted-foreground">{p.path}</span>
            <span className="shrink-0 font-black text-primary" dir="ltr">
              {p.avg_ms} ms · {p.hits}
            </span>
          </li>
        ))}
      </ul>
    </NeuCard>
  );
};
